var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-teaser-data"},[_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.resultTeaserData.supportText)}}),_vm._v(" "),_c('div',{staticClass:"action"},[_c('button',{on:{"click":_vm.support}},[_vm._v(_vm._s(_vm.resultTeaserData.supportLinkText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }